<!-- no items -->
@if (!pageable?.visibleNodes?.length) {
  @if (pageable?.isLoading) {
    <rcp-skeleton-table></rcp-skeleton-table>
  } @else {
    @if (noDataTemplateRef) {
      <ng-container [ngTemplateOutlet]="noDataTemplateRef"> </ng-container>
    } @else {
      <rcp-info-box>
        {{ 'qz-no-results-zm' | translate }}
      </rcp-info-box>
    }
  }
}

@if (!!pageable?.visibleNodes?.length) {
  <div class="table-container box-border overflow-visible">
    <!-- Table -->
    <table class="table table-pull">
      <!-- header -->
      @if (headerTemplateRef) {
        <ng-container
          [ngTemplateOutlet]="headerTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: toggleCheckAll.bind(this) }"
        >
        </ng-container>
      }
      <!-- rows  -->
      @for (rowData of pageable.visibleNodes; track rowData) {
        <ng-container
          [ngTemplateOutlet]="rowTemplateRef"
          [ngTemplateOutletContext]="{
            $implicit: rowData,
            toggleCheck: toggleCheckRow.bind(this),
            selected: selected,
          }"
        >
        </ng-container>
      }
      <!-- summary -->
      @if (summaryTemplateRef) {
        <ng-container [ngTemplateOutlet]="summaryTemplateRef"> </ng-container>
      }
    </table>
    @if (pageable?.hasNextPage) {
      <div class="load-more-results" rcpScrollIntoView (scrollIntoView)="onScrollIntoView()" [persistant]="true">
        @if (pageable.isLoadingMore) {
          <rcp-loading-indicator></rcp-loading-indicator>
        } @else {
          <rcp-text-link-action (click)="getNextPage()" [icon]="faAngleDown">
            {{ 'qz-show-more-zm' | translate }}
          </rcp-text-link-action>
        }
      </div>
    }
  </div>
}
